<!-- <h4 class="text-lg font-bold">
  @if (((openedModals$ | async) ?? 0) > 1) {
    <i (click)="close(undefined)" class="fa-regular fa-angle-left"></i>
  }
  {{'#TICKETS.DIALOGS.CHECK_LIST.TITLE' | translate}}
</h4> -->

@if (checkpoints$ | async; as checkpoints) {
  @if (checkpointStates$ | async; as checkpointStates) {
    <div class="tableFixHead">
      <div class="grid grid-cols-auto items-center gap-1 pr-2">
        @for (checkpoint of checkpoints; track checkpoint; let i = $index) {
          <div
            class="grid grid-cols-subgrid col-span-6 items-center hover:bg-hover p-1 rounded"
          >
            <div>
              <span class="text-sm">{{ i + 1 }}</span>
            </div>
            <div
              *ngVar="
                checkpointStates
                  | filter: filterCheckPointState : checkpoint.id
                  | first as state
              "
            >
              @if (strategy().stage) {
                <soft-checkbox
                  [value]="state?.done || false"
                  (click)="$event.stopPropagation()"
                  (valueChange)="
                    state?.done !== checkbox.value
                      ? setDone($event, checkpoint, checkbox.value, state)
                      : undefined
                  "
                  #checkbox
                ></soft-checkbox>
              }
            </div>
            <div>
              {{ checkpoint.name }}
            </div>
            <div class="flex flex-col mt-2">
              @if (checkpoint.note) {
                <span class="soft-label top">{{
                  '#TICKETS.DIALOGS.CHECK_LIST.NOTE' | translate
                }}</span>
                {{ checkpoint.note }}
              }
            </div>
            <div class="flex flex-col mt-2">
              @if (checkpoint.error) {
                <span class="soft-label top">{{
                  '#TICKETS.DIALOGS.CHECK_LIST.ERROR' | translate
                }}</span>
                {{ checkpoint.error }}
              }
            </div>
            <div
              softToolTip="Eintrag bearbeiten"
              class="text-primary bg-primary-50 rounded-full p-3 cursor-pointer hover:bg-hover"
              (click)="edit(checkpoint, 'update')"
            >
              <soft-icon name="fa-regular fa-pen-to-square"></soft-icon>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="flex flex-row justify-center m-2">
      <span>
        @if (checkpoints.length === 0) {
          {{ '#TICKETS.DIALOGS.CHECK_LIST.NO_DATA' | translate }}
        }
      </span>
      <div
        softToolTip="Checkpoint hinzufügen"
        class="flex justify-center mt-2 text-primary bg-primary-50 rounded-full p-3 cursor-pointer hover:bg-hover"
        (click)="edit(undefined, 'create')"
      >
        <soft-icon name="fa-regular fa-plus"></soft-icon>
        <span>{{ '#TICKETS.DIALOGS.CHECK_LIST.ADD' | translate }}</span>
      </div>
    </div>
  }
}

@if (action) {
  <div>
    <hr />
    <div class="mt-2">
      @switch (action) {
        @case ('create') {
          <div class="flex flex-row justify-between">
            <h5 class="font-bold">
              {{ '#TICKETS.DIALOGS.CHECK_LIST.CREATE.TITLE' | translate }}
            </h5>
            <a class="pointer" (click)="cancelEdit()"
              ><i class="fa-regular fa-angle-up"></i
            ></a>
          </div>
          <form [formGroup]="form">
            <div class="flex flex-row flex-nowrap mt-4">
              <div class="flex flex-col">
                <span class="soft-label top">{{
                  '#TICKETS.DIALOGS.CHECK_LIST.TYPE' | translate
                }}</span>
                <soft-select formControlName="type">
                  @for (type of strategy().availableTypes; track type) {
                    <soft-select-option [value]="type">
                      {{
                        '#TICKETS.DIALOGS.CHECK_LIST.CHECK_POINT_TYPE.' +
                          (type | uppercase) | translate
                      }}
                    </soft-select-option>
                  }
                </soft-select>
              </div>
              <div class="flex flex-col ml-4">
                <span class="soft-label top">{{
                  '#TICKETS.DIALOGS.CHECK_LIST.NAME' | translate
                }}</span>
                <soft-input formControlName="name" />
              </div>
            </div>
            <div class="flex flex-row justify-end mt-2">
              <button
                type="submit"
                class="soft-button primary rounded hover:cursor-pointer"
                (click)="save(form.value, action)"
              >
                {{ '#TICKETS.DIALOGS.CHECK_LIST.CREATE.SUBMIT' | translate }}
              </button>
            </div>
          </form>
        }
        @case ('update') {
          <div class="flex flex-row justify-between">
            <h5 class="font-bold">
              {{ '#TICKETS.DIALOGS.CHECK_LIST.UPDATE.TITLE' | translate }}
            </h5>
            <a class="pointer" (click)="cancelEdit()"
              ><i class="fa-regular fa-angle-up"></i
            ></a>
          </div>
          <form [formGroup]="form">
            <div class="flex flex-col mt-2">
              <span class="soft-label top">{{
                '#TICKETS.DIALOGS.CHECK_LIST.NAME' | translate
              }}</span>
              <soft-input formControlName="name" />
            </div>
            <div class="flex flex-col mt-2">
              <span class="soft-label top">{{
                '#TICKETS.DIALOGS.CHECK_LIST.NOTE' | translate
              }}</span>
              <soft-input formControlName="note" />
            </div>
            <div class="flex flex-col mt-2">
              <span class="soft-label top">{{
                '#TICKETS.DIALOGS.CHECK_LIST.ERROR' | translate
              }}</span>
              <soft-input formControlName="error" />
            </div>
            <div class="flex flex-row justify-end mt-2">
              <button
                type="submit"
                class="soft-button rounded hover:cursor-pointer hover:text-danger"
                (click)="edit(form.value, 'delete')"
              >
                {{ '#TICKETS.DIALOGS.CHECK_LIST.DELETE.ACTION' | translate }}
              </button>
              <button
                type="submit"
                class="soft-button primary rounded hover:cursor-pointer"
                (click)="save(form.value, action)"
              >
                {{ '#TICKETS.DIALOGS.CHECK_LIST.UPDATE.SUBMIT' | translate }}
              </button>
            </div>
          </form>
        }
        @case ('delete') {
          <div class="flex flex-row justify-between">
            <h5 class="font-bold">
              {{ '#TICKETS.DIALOGS.CHECK_LIST.DELETE.TITLE' | translate }}
            </h5>
            <a class="pointer" (click)="cancelEdit()"
              ><i class="fa-regular fa-angle-up"></i
            ></a>
          </div>
          <div class="mt-4">
            {{ '#TICKETS.DIALOGS.CHECK_LIST.DELETE.MESSAGE' | translate }}
          </div>
          <div class="flex flex-row justify-end mt-2">
            <button
              type="submit"
              class="soft-button rounded hover:cursor-pointer"
              (click)="edit(form.value, 'update')"
            >
              {{ '#TICKETS.DIALOGS.CHECK_LIST.DELETE.CANCEL' | translate }}
            </button>
            <button
              type="submit"
              class="soft-button primary rounded hover:cursor-pointer"
              (click)="save(form.value, action)"
            >
              {{ '#TICKETS.DIALOGS.CHECK_LIST.DELETE.SUBMIT' | translate }}
            </button>
          </div>
        }
      }
    </div>
  </div>
}
